export const DEFAULT_PDF_WIDTH_WEB = 580;

//duration in milliseconds
export const IDLE_DURATION = 3e3;

export const MAX_PROGRESS = 100;
